// 工具栏按钮的图标：除注明的以外是 Lucide 0.460（ISC 许可）的原始图形，名字与 Lucide 一致，外框由 ui 的 Icon 统一（设计系统"图标"一节）。
import type { ReactNode } from "react";
import { Icon } from "@/ui";

const PATHS = {
  "columns-3": <><rect width="18" height="18" x="3" y="3" rx="2" /><path d="M9 3v18" /><path d="M15 3v18" /></>,
  filter: <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />,
  // 任务中心（决策 D205）：三个小圆在一个大圆上，三段弧把它们连成一圈，用户 2026-10-15 给的样式；Lucide 没有，按它的线宽与端点画
  tasks: <><circle cx="12" cy="6.75" r="2.5" /><circle cx="18.06" cy="17.25" r="2.5" /><circle cx="5.94" cy="17.25" r="2.5" /><path d="M14.46 7.2A7 7 0 0 1 18.91 14.9" /><path d="M16.45 19.16A7 7 0 0 1 7.55 19.16" /><path d="M5.09 14.9A7 7 0 0 1 9.54 7.2" /></>,
  "filter-x": <><path d="M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055" /><path d="m22 3-5 5" /><path d="m17 3 5 5" /></>,
  monitor: <><rect width="20" height="14" x="2" y="3" rx="2" /><path d="M8 21h8" /><path d="M12 17v4" /></>,
  moon: <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2" /><path d="M12 20v2" /><path d="m4.93 4.93 1.41 1.41" /><path d="m17.66 17.66 1.41 1.41" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="m6.34 17.66-1.41 1.41" /><path d="m19.07 4.93-1.41 1.41" /></>,
} satisfies Record<string, ReactNode>;

/** 工具栏按钮前的图标，例如只有图标的“筛选条件”“显示列”“清除筛选”（决策 D198）、顶栏的主题切换（决策 D200）与任务中心（决策 D205）。 */
export function ToolIcon({ name }: { name: keyof typeof PATHS }) {
  return <Icon>{PATHS[name]}</Icon>;
}
